import React from 'react';
import { connect } from "react-redux";
import { branch, compose, lifecycle, renderComponent, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { businessActions, businessCurrentTeamSelector, businessSelector, businessCurrentTeamNonMemberManagersSelector } from '../../../../state/modules/business';
import Loading from '../../loading';
import TeamDetails from './team-details';

const TeamEdit = ({ currentTeamWithNonMemberManagers }) => (
  <div id='team-edit'>
    <TeamDetails team={currentTeamWithNonMemberManagers} />
  </div>
);

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  currentTeam: businessCurrentTeamSelector(state),
  currentTeamNonMemberManagers: businessCurrentTeamNonMemberManagersSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
  getTeam: bindActionCreators(businessActions.business.team.getTeam, dispatch),
  getNonMemberManagers: bindActionCreators(businessActions.business.team.getNonMemberManagers, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({
      match: {
        params: {
          businessTeamId
        }
      }
    }) => ({
      businessTeamId
    })
  ),
  branch(
    ({ business }) => !business,
    renderComponent(Loading)
  ),
  lifecycle({
    componentDidMount() {
      const {
        business,
        businessTeamId,
        getTeam,
        getNonMemberManagers
      } = this.props;
      getTeam(business.id, businessTeamId);
      getNonMemberManagers(business.id, businessTeamId);
    }
  }),
  withProps(({ currentTeam, currentTeamNonMemberManagers }) => {
    const currentTeamWithNonMemberManagers = {
      ...currentTeam,
      nonMemberManagers: currentTeamNonMemberManagers
    };
    return {currentTeamWithNonMemberManagers};
  }),
  branch(
    ({ currentTeam }) => !currentTeam,
    renderComponent(Loading)
  ),
)(TeamEdit);


// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/team-edit.js